// extracted by mini-css-extract-plugin
module.exports = {"ModalInputLabel":"kQhk4q1TKAD-JCE_8ZhLY","securityDeleteDialog":"_1EMQa6HDBSjFJFVgfvbWwP"};